export default [
  {
    srno: "01",
    name: "sahil kanerkar",
    mobile: "9892130802",
    email: "sahil.kanerkar@aiab.in",
    id: "12345678901",
    sessiontype: "Online",
  },
  {
    srno: "02",
    name: "Sumit Jaiswal",
    mobile: "9892130801",
    email: "sumit.jaiswal@aiab.in",
    id: "2314567182",
    sessiontype: "Online",
  },
  {
    srno: "03",
    name: "Yash Singh",
    mobile: "9892130701",
    email: "yash.singh@aiab.in",
    id: "2314567182",
    sessiontype: "Online",
  },
];
